import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import {
	SimpleForm,
	translate,
	TextInput,
	required,
} from 'react-admin';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import { submit } from 'redux-form';
import SimpleButton from '@material-ui/core/Button';
import SaveButton from '../common/SaveButton';
import { format } from 'date-fns'

const styles = {
	button: { marginRight: '1em', marginLeft: '1em' },
	label: { marginLeft: '1em', marginRight: '1em' },
	redlabel: { marginLeft: '1em', marginRight: '1em', color: 'red' },
};

const bytes = (str) => {
	str = (str == null) ? "" : str;
	return (encodeURI(str).replace(/%../g, "x").length);
}

const validatemaxBytes = (value, allValues, props) => {
	if (bytes(value) > 100) {
		return props.translate('ra.validation.tooLong');
	}
}
const validateName = [required(), validatemaxBytes];

class ResourcePairingButton extends Component {
	constructor(props) {
		super(props)
		this.state = {
			showDialog: false,
			isValidCount: false,
		};
	}

	handleClick = () => {
		const { selectedIds } = this.props;
		this.setState({ showDialog: true, isValidCount: selectedIds.length <= 50 });
	}

	handleCloseClick = () => {
		this.setState({ showDialog: false });
	};

	handleSaveClick = () => {
		const { submit } = this.props;
		submit('get-pairing-code');
	};

	handleSubmit = values => {
		const { selectedIds: resourceIds, translate } = this.props;
		const { name } = values;
		const codeWindow = this.openPairingCodeWindow(name);

		const options = {
			method: 'POST',
			credentials: 'include',
			mode: 'cors',
			body: JSON.stringify({ name, resourceIds })
		}
		var request = new Request(process.env.REACT_APP_RSB_API_ENDPOINT + '/resources-pairing');

		fetch(request, options)
			.then(response => response.json())
			.then(json => this.showPairingCode(json, codeWindow, translate));

		this.setState({ showDialog: false });
	}

	openPairingCodeWindow(name) {
		const codeWindow = window.open(`${process.env.PUBLIC_URL}/pairingcode.html`);
		codeWindow.onload = function () { this.document.title = name };
		return codeWindow;
	}

	showPairingCode(json, codeWindow, translate) {
		const doc = codeWindow.document;
		doc.getElementById("codeTitle").innerHTML = translate('resources.resources.fields.pairingCode');
		doc.getElementById("expiredDateTitle").innerHTML = translate('resources.resources.fields.pairingExpiredDate') + ': ';
		doc.getElementById("pairingGuidance").innerHTML = translate('resources.resources.fields.pairingGuidance2');
		doc.getElementById("nameTitle").innerHTML = translate('resources.resources.fields.pairingDeviceName');
		doc.getElementById("name").innerHTML = json.name;

		const codeChars = json.id.split('');
		const splitedCodeChars = codeChars.map((c, i) => {
			if ((i % 4 == 0) && (i / 4 >= 1)) {
				return ' ' + c;
			}
			return c;
		});
		doc.getElementById("code").innerHTML = splitedCodeChars.join("");

		const date = new Date(json.expiredDate);
		doc.getElementById("expiredDate").innerHTML = format(date, "yyyy/MM/dd HH:mm");

		const ul = doc.getElementById("resourceList");
		json.resourceNames.map(name => {
			let li = doc.createElement("li");
			li.appendChild(doc.createTextNode(name));
			ul.appendChild(li);
		});
		doc.getElementById("resourceTitle").innerHTML = translate('resources.resources.fields.pairingResourceName') + '(' + json.resourceNames.length + ')';
	}

	render() {
		const { showDialog, isValidCount } = this.state;
		const { translate } = this.props;
		return (
			<Fragment>
				<SimpleButton variant="outlined" onClick={this.handleClick} style={styles.button} color="primary">{translate('resources.resources.fields.pairingResource')}</SimpleButton>
				<Dialog
					fullWidth
					open={showDialog}
					onClose={this.handleCloseClick}
				>
					<DialogTitle>{translate('resources.resources.fields.pairingResource')}</DialogTitle>
					{
						isValidCount ? (
							<DialogContentText style={styles.label}>
								{translate('resources.resources.fields.pairingGuidance1')}
							</DialogContentText>
						) : (
								<DialogContentText style={styles.redlabel}>
									{translate('resources.resources.fields.pairingGuidance3')}
								</DialogContentText>
							)
					}
					{
						isValidCount && (
							<DialogContent>
								<SimpleForm toolbar={null} form='get-pairing-code' onSubmit={this.handleSubmit}>
									<TextInput source="name" label='resources.resources.fields.pairingDeviceName' validate={validateName} />
									<TextInput source="dummy" style={{ display: 'none' }} />
								</SimpleForm>
							</DialogContent>
						)
					}
					<DialogActions>
						{
							isValidCount && (
								<SaveButton
									label='resources.resources.fields.startPairing'
									onClick={this.handleSaveClick}
								/>
							)
						}
						<SimpleButton onClick={this.handleCloseClick} color='primary'>
							{
								isValidCount ? translate('ra.action.cancel') : translate('common.close')
							}
						</SimpleButton>
					</DialogActions>
				</Dialog>
			</Fragment>
		);
	}
}

ResourcePairingButton.propTypes = {
	selectedIds: PropTypes.array,
};

const enhance = compose(
	translate,
	withStyles(styles),
	connect(
		undefined,
		{ submit }
	),
);

export default enhance(ResourcePairingButton);